import { styled, Typography } from "@mui/material";
import { Link } from "../../external/react-router-dom/dist/index.js";
import { shouldNotForwardProps } from "../../utils/shouldNotForwardProps.js";
const StyledTypography = styled(Typography)(
  ({ theme, color, disabled }) => ({
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    ...color === "primary" && {
      color: theme.palette.primary[900],
      "@media (hover: hover)": {
        "&:hover": {
          color: theme.palette.primary[800]
        }
      },
      "&:active": {
        color: theme.palette.primary[1e3]
      }
    },
    ...color === "secondary" && {
      color: theme.palette.secondary[900],
      "@media (hover: hover)": {
        "&:hover": {
          color: theme.palette.secondary[800]
        }
      },
      "&:active": {
        color: theme.palette.secondary[1e3]
      }
    },
    ...color === "invert" && {
      color: theme.palette.white.main,
      "@media (hover: hover)": {
        "&:hover": {
          color: theme.palette.grey[100]
        }
      },
      "&:active": {
        color: theme.palette.grey[200]
      }
    },
    ...color === "quaternary" && {
      color: theme.palette.grey[800],
      "@media (hover: hover)": {
        "&:hover": {
          color: theme.palette.grey[700]
        }
      },
      "&:active": {
        color: theme.palette.grey[1e3]
      }
    },
    ...color === "tertiary" && {
      color: theme.palette.grey[400],
      "@media (hover: hover)": {
        "&:hover": {
          color: theme.palette.grey[500]
        }
      },
      "&:active": {
        color: theme.palette.grey[600]
      }
    },
    ...disabled && {
      color: theme.palette.grey[400],
      pointerEvents: "none"
    }
  })
), StyledLink = styled(
  "a",
  shouldNotForwardProps(["disabled"])
)(({ disabled }) => ({
  width: "fit-content",
  ...disabled && {
    pointerEvents: "none"
  }
})), StyledIcon = styled("div")(
  ({ size }) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "18px",
    height: "18px",
    ...size === "xl" && {
      width: "24px",
      height: "24px"
    }
  })
), StyledButtonLink = styled("button")(() => ({
  display: "inline-flex",
  padding: 0,
  border: "none",
  backgroundColor: "transparent",
  width: "fit-content",
  cursor: "pointer",
  "&:disabled": {
    pointerEvents: "none"
  }
})), StyledButtonReactLink = styled(Link)(
  ({ disabled }) => ({
    width: "fit-content",
    ...disabled && {
      pointerEvents: "none"
    }
  })
);
export {
  StyledButtonLink,
  StyledButtonReactLink,
  StyledIcon,
  StyledLink,
  StyledTypography
};
//# sourceMappingURL=styles.js.map
